export default "__VITE_ASSET__jyTVpYzf__"